/**
 * Chrome auto-translate wraps text nodes in <font> tags, which breaks React's
 * DOM reconciliation (NotFoundError on removeChild). Patch removeChild/
 * insertBefore so the app keeps working when the user enables translation.
 */
const patchDomForGoogleTranslate = () => {
	const originalRemoveChild = Node.prototype.removeChild;
	Node.prototype.removeChild = function removeChild(child) {
		if (child.parentNode !== this) {
			return child;
		}
		return originalRemoveChild.call(this, child);
	};

	const originalInsertBefore = Node.prototype.insertBefore;
	Node.prototype.insertBefore = function insertBefore(newNode, referenceNode) {
		if (referenceNode && referenceNode.parentNode !== this) {
			return originalInsertBefore.call(this, newNode, null);
		}
		return originalInsertBefore.call(this, newNode, referenceNode);
	};
};

patchDomForGoogleTranslate();
